import React from 'react';
import Header from '../Header';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';
import { useBranding } from '../../hooks/useBranding';

const Layout = ({ children }) => {
    const { branding, loading } = useBranding();

    if (loading || !branding) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
            </Box>
        );
    }

    const page = {
        background: branding.primaryColor,
        minHeight: '100vh',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    };

    const contactText = `Call ${branding.contact.phone} or email ${branding.contact.email} with questions`;

    return (
        <Box sx={page}>
            <Box sx={{ padding: 2 }}>
                <Paper elevation={3} sx={{ margin: '0 auto', maxWidth: 1280, padding: 2, paddingBottom: 4 }}>
                    <Header />
                    {children}
                </Paper>
            </Box>
            <Box sx={{ margin: '0 auto', maxWidth: 900, fontSize: '.8rem', paddingBottom: 4, color: '#fff' }}>
                <Typography variant='body2' component={'span'}>
                    {contactText}
                </Typography>
            </Box>
        </Box>)
};

export default Layout;
